<script setup lang="ts"></script>

<template>
  <footer class="footer footer-center pb-5 text-base-content rounded">
    <p>
      NeoFlex, &copy; 2023-2024
      <span>NEOWIZ</span>
    </p>
  </footer>
</template>

<style lang="scss">
  .footer {
    p {
      display: block;
      color: #8a8c8f;

      span {
        color: #e51937;
        font-weight: 500;
      }
    }
  }
</style>
